// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__Hz2ee","logo":"Footer_logo__nOaWf","links":"Footer_links__E7aK-","separator":"Footer_separator__YFwC4","footnote":"Footer_footnote__zKp9A"};